const ENVIRONMENTS = {
  dev: {
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    customComBase: "https://comm.clairedev.nl/api/customcom/v1",
    customComBaseV2: "https://comm.clairedev.nl/api/customcom/v2",
    appointmentBase: "https://comm.clairedev.nl/api/appointment/v1",
    deskComBase: "https://comm.clairedev.nl/api/desk/v1",
    authBase: "https://comm.clairedev.nl/api/auth/v1",
    keylockerBase: "https://comm.clairedev.nl/api/keylocker/v1",
    kioskBase: "https://comm.clairedev.nl/api/kiosk/v1",
    systemBase: "https://comm.clairedev.nl/api/system/v1",
    dealerBaseUrl: "https://comm.clairedev.nl/api/dealer/v1",
  },
  local: {
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    customComBase: "https://comm.clairedev.nl/api/customcom/v1",
    customComBaseV2: "https://comm.clairedev.nl/api/customcom/v2",
    appointmentBase: "https://comm.clairedev.nl/api/appointment/v1",
    deskComBase: "https://comm.clairedev.nl/api/desk/v1",
    authBase: "https://comm.clairedev.nl/api/auth/v1",
    keylockerBase: "https://comm.clairedev.nl/api/keylockerv1",
    kioskBase: "https://comm.clairedev.nl/api/kiosk/v1",
    systemBase: "https://comm.clairedev.nl/api/system/v1",
  },
  localWithBackend: {
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    customComBase: "http://127.0.0.1:8086/api/customcom/v1",
    customComBaseV2: "http://127.0.0.1:8086/api/customcom/v2",
    appointmentBase: "http://127.0.0.1:8082/api/appointment/v1",
    deskComBase: "http://127.0.0.1:8088/api/desk/v1",
    keylockerBase: "http://127.0.0.1:8096/api/keylocker/v1",
    authBase: "http://127.0.0.1:8083/api/auth/v1",
    kioskBase: "http://127.0.0.1:8098/api/kiosk/v1",
    systemBase: "http://127.0.0.1:8106/api/system/v1",
  },
  prod: {
    clientID: "674901036874-hrv3lhqlkp3b0uh8lhoaj0hlmrqd37it.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.claireit.com",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    appointmentBase: "https://mycarcheck.pro/api/appointment/v1",
    customComBase: "https://mycarcheck.pro/api/customcom/v1",
    customComBaseV2: "https://mycarcheck.pro/api/customcom/v2",
    authBase: "https://mycarcheck.pro/api/auth/v1",
    deskComBase: "https://mycarcheck.pro/api/desk/v1",
    keylockerBase: "https://mycarcheck.pro/api/keylocker/v1",
    kioskBase: "https://mycarcheck.pro/api/kiosk/v1",
    systemBase: "https://mycarcheck.pro/api/system/v1",
    dealerBaseUrl: "https://mycarcheck.pro/api/dealer/v1",
  },
};

const ENV = ENVIRONMENTS[process.env.REACT_APP_ENV];

export default ENV;
